import React, { useRef, memo, useEffect } from "react";

import { capitalize } from "src/utils";
import { ErrorBind } from "src/primitives";
import loadComponent from "src/component-loader";
import { componentMounted, paintInfo } from "src/custom-events";

import { useSticky } from "./utils";

const Item = memo(({ config, index, parent, parentIndex, ...rest }) => {
  const ref = useRef();

  const { name, id, props = {}, content } = config;

  useEffect(() => {
    const isRoot = location.pathname == "/";

    if (isRoot) {
      if (parent) {
        componentMounted(name, props, `${parentIndex}_${capitalize(parent.name)}_${index}`);
      } else {
        componentMounted(name, props, index);
      }
    }
  }, []);
  const isSticky = props["stickToTop"] || name === "navComponent";
  useSticky(ref, isSticky);

  const Component = loadComponent(name);

  return (
    <section ref={ref} data-af-component={capitalize(name)}>
      {content ? (
        <Component {...props} id={id} name={name} _contentIndex={index} _contentParent={parent} {...rest}>
          <Content content={content} _contentIndex={index} _contentParent={config} />
        </Component>
      ) : (
        <Component {...props} id={id} name={name} _contentIndex={index} _contentParent={parent} {...rest} />
      )}
    </section>
  );
});

const Content = memo(props => {
  const { content = [], _contentParent, _contentIndex, ...rest } = props;

  // Call when content mounted
  useEffect(() => {
    if (!_contentParent) {
      componentMounted("App");
      paintInfo();
    }
  }, []);

  return content.map((config, index) => (
    <ErrorBind key={index} item={config}>
      <Item config={config} index={index} parent={_contentParent} parentIndex={_contentIndex} {...rest} />
    </ErrorBind>
  ));
});

export default Content;
